export function fullPageSlug(slug?: string): string {
  if(!slug) {
    return `https://${process.env['NEXT_PUBLIC_WEB_URL']}`;
  }
  return `https://${process.env['NEXT_PUBLIC_WEB_URL']}/${slug}`;
}
